import script from "./SideBarImage.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarImage.vue?vue&type=script&setup=true&lang=js"

import "./SideBarImage.vue?vue&type=style&index=0&id=4f4d2a80&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4d2a80"]])

export default __exports__